import PropTypes from 'prop-types';
import React, { Component } from 'react';
import HistoryIcon from './HeaderButton/HistoryIcon';
import SettingsIcon from './HeaderButton/SettingsIcon';
import { withRouter } from 'react-router';
import { connect } from "react-redux";

// SASS Imports
require("./Header.scss");

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        editingEntry: state.editingEntry
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {};
}

// Header Component
class Header extends Component {
    constructor(props) {
        super(props);
        this.onClickHeader = this.onClickHeader.bind(this);
    }


    onClickHeader() {
        this.props.router.push('/');
    }

    render() {
        return (
            <header className="row">
                <HistoryIcon
                    label="Entries"
                    cssClass={"btn-header sit-left " + ((this.props.historyStatus) ? "nav-btn-active" : "")}
                    historyToggle={this.props.historyToggle}
                />
                <a className="logo" onClick={this.onClickHeader}>
                    <img
                        src={require('./assets/mgtt_logo.png')}
                        alt="Mentor Graphics Time Tracker"
                    />
                </a>
                {(this.props.user.firstName) ?
                    <div className="header-right sit-right">
                        <div className="usernameDisplay">
                            <p>Welcome,</p>
                            <h3>
                                {(this.props.user.firstName)
                                    ? this.props.user.firstName + " " + this.props.user.lastName
                                    : ''}
                            </h3>
                        </div>
                        <SettingsIcon
                            label="Settings"
                            cssClass={"btn-header pull-right " + ((this.props.settingsStatus) ? "nav-btn-active" : "")}
                            settingToggle={this.props.settingToggle}
                        />
                    </div>:null}
            </header>
        );
    }
}

let DecoratedHeader = withRouter(Header);

Header.propTypes = {
    router: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(DecoratedHeader);



// WEBPACK FOOTER //
// ./app/components/Header/Header.jsx